export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}
export const SORT_DIRECTION_DEFAULT = SortDirection.ASC;
